import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MultasComponent } from './pages/multas/multas.component';
import { MultasController } from './controllers';
import { IConfig, NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { AppMaterialModule } from '@app/app-material.module';
import { AnimationsModule } from '@app/shared/animations/animations.module';
import { ComponentsModule } from '@app/shared/components/components.module';
import { DetalhesMultaComponent } from './components/detalhes-multa/detalhes-multa.component';
import { AddCondutorContratoComponent } from './components/add-condutor-contrato/add-condutor-contrato.component';
import { AddCondutorComponent } from './components/add-condutor/add-condutor.component';

const maskConfig: Partial<IConfig> = {
  validation: false,
};

@NgModule({
  declarations: [
    MultasComponent,
    DetalhesMultaComponent,
    AddCondutorContratoComponent,
    AddCondutorComponent,
  ],
  imports: [
    RouterModule,
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    AppMaterialModule,
    ComponentsModule,
    NgxMaskDirective,
    NgxMaskPipe,
    AnimationsModule,
  ],
  providers: [provideNgxMask(maskConfig), MultasController],
})
export class MultasModule { }
